module.exports = __webpack_public_path__ + "static/media/page3-pigs.d7368624.png";